import * as DOMPurify from 'dompurify';

function SanitizeHTMLString(value?: string|null) {

    return DOMPurify.sanitize(value || "",{ FORCE_BODY: true })

}

export default SanitizeHTMLString;
